import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HELPER_CHANGELOG, HELPER_LATEST_VERSION, helperVersion } from "@/lib/helper";

export default function HelperChangelog() {
  const installed = helperVersion();
  return (
    <Accordion type="single" collapsible defaultValue={HELPER_LATEST_VERSION} data-testid="settings-helper-changelog">
      {HELPER_CHANGELOG.map((c) => (
        <AccordionItem key={c.v} value={c.v} className="border-border">
          <AccordionTrigger className="text-sm" data-testid={`helper-changelog-${c.v}`}>
            <span className="flex items-center gap-2">
              <span className="font-mono text-primary">v{c.v}</span>
              {c.v === HELPER_LATEST_VERSION && <span className="rounded-full bg-primary/15 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-primary">Terbaharu</span>}
              {c.v === installed && <span className="rounded-full bg-emerald-500/15 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-emerald-300">Terpasang</span>}
            </span>
          </AccordionTrigger>
          <AccordionContent>
            <ul className="list-disc space-y-1 pl-5 text-sm text-muted-foreground">
              {c.items.map((it) => <li key={it}>{it}</li>)}
            </ul>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
